<div class="main-container__full animated fadeIn">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item" aria-current="page">
				<a [routerLink]="['/shop']" class="icon-back"></a>
				Home
			</li>
			<li class="breadcrumb-item active" aria-current="page">
				<a href="javascript:void(0)" class="fw-bolder text-primary">{{productListType}}</a>
			</li>
		</ol>
	</nav>
	<h1 class="fw-bolder animated fadeInLeft mt-4">
		{{productListType}}
	</h1>
	<section class="d-grid col-12 my-4">
		<h5 class="fw-bolder text-body-tertiary opacity-50 animated fadeIn">A la carte</h5>
		<div class="product-card-grid">
			<div class="row">
				@defer (on immediate; when productsService.productsSelectionListSignal().onetime.length) {
				@if (productsService.productsSelectionListSignal().onetime) {

				@for (product of productsService.productsSelectionListSignal().onetime; track product.variantId) {
				@defer (on viewport; prefetch on immediate) {
				<div class="col-xxl-3 col-lg-4 col-6">
					<div class="product-card-grid__item">
						<app-product-card-v2
							[cardResume]="{ settings: {}, productDetails: product }"></app-product-card-v2>
					</div>
				</div>
				}
				@placeholder {
				<div class="col-xxl-3 col-lg-4 col-6" id="{{product.id}}">
					<section class="d-flex flex-column flex-grow-1">
						<div class="product-card__head"></div>
						<div class="product-card__img-wrap">
							<a>
								<div class="product-card__img"></div>
							</a>
						</div>
						<div style="height: 150px;"></div>
					</section>
				</div>
				}
				}
				}
				}
				@placeholder { LOADING... }
			</div>
		</div>
	</section>
	<section class="d-grid col-12 my-4">
		<h5 class="fw-bolder text-body-tertiary opacity-50 animated fadeIn">Subscriptions</h5>

		<div class="container-fluid">
			<div class="row product-card-grid">
				@defer (on immediate; when productsService.productsSelectionListSignal().subscription.length) {
				@if (productsService.productsSelectionListSignal().subscription) {

				@for (product of productsService.productsSelectionListSignal().subscription; track product.variantId) {
				@defer (on viewport; prefetch on immediate) {
				<div class="col-xxl-3 col-lg-4 col-6">
					<div class="product-card-grid__item">
						<app-product-card-v2
							[cardResume]="{ settings: {}, productDetails: product }"></app-product-card-v2>
					</div>
				</div>
				}
				@placeholder {
				<div class="col-xxl-3 col-lg-4 col-6" id="{{product.id}}">
					<section class="d-flex flex-column flex-grow-1">
						<div class="product-card__head"></div>
						<div class="product-card__img-wrap">
							<a>
								<div class="product-card__img"></div>
							</a>
						</div>
						<div style="height: 150px;"></div>
					</section>
				</div>
				}
				}
				}

				}
				@placeholder { LOADING... }
			</div>
		</div>
	</section>
</div>